import { ErrorMessageStrategy, ResponseError } from '@shared/utils/interfaces';

export const workspaceOwnerAlreadyActiveStrategy: ErrorMessageStrategy = (error: ResponseError) => ({
  translationKey: 'errors.WORKSPACE_OWNER_ALREADY_ACTIVE',
  translationParams: {
    productName: error.objects[0],
    email: error.objects[1],
  },
});
